import { render, staticRenderFns } from "./RegisterListCover.page.vue?vue&type=template&id=ca20fcfe&"
import script from "./RegisterListCover.page.vue?vue&type=script&lang=js&"
export * from "./RegisterListCover.page.vue?vue&type=script&lang=js&"
import style0 from "./RegisterListCover.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports